import "./App.css";
import Page from "./Components/Page";
import Page2 from "./Components/page2";
function App() {
  return (
    <>
      <Page />
      {/* <Page2 /> */}
    </>
  );
}

export default App;
